import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FlameIcon, ArrowRightIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { EmailSignupPrompt } from '../components/EmailSignupPrompt';
import { getRandomValidation } from '../utils/rantUtils';
import { supabase } from '../config/supabaseClient';
export const ConfirmationPage: React.FC = () => {
  const [validationMessage, setValidationMessage] = useState<string>(getRandomValidation());
  const [showEmailPrompt, setShowEmailPrompt] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    // More thorough auth check with longer timeout
    const checkAuth = async () => {
      try {
        // Wait a bit longer for Supabase to restore session
        await new Promise(resolve => setTimeout(resolve, 1000));
        // Check both session and user
        const {
          data: {
            session
          }
        } = await supabase.auth.getSession();
        const {
          data: {
            user
          }
        } = await supabase.auth.getUser();
        // Only show prompt if both checks confirm no auth
        const isAuthenticated = !!(session && user);
        setShowEmailPrompt(!isAuthenticated);
      } catch (error) {
        console.error('Error checking auth:', error);
        // On error, default to showing prompt
        setShowEmailPrompt(true);
      } finally {
        setIsCheckingAuth(false);
      }
    };
    checkAuth();
    // Listen for auth state changes
    const {
      data: authListener
    } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        setShowEmailPrompt(false);
      } else if (event === 'SIGNED_OUT') {
        //        setShowEmailPrompt(true)
      }
    });
    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-234">
      <Header data-id="element-235" />
      <main className="flex-grow flex flex-col items-center justify-center py-12 px-4 relative overflow-hidden" data-id="element-236">
        {/* Celebratory Flaming Poop Emojis */}
        {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute text-5xl pointer-events-none" style={{
        left: `${10 + i * 10}%`,
        top: `${20 + i % 3 * 20}%`
      }} initial={{
        opacity: 0,
        scale: 0,
        rotate: 0
      }} animate={{
        opacity: [0, 1, 1, 0],
        scale: [0, 1.2, 1, 0.8],
        rotate: [0, 360],
        y: [-20, -60, -100]
      }} transition={{
        duration: 3,
        delay: i * 0.2,
        repeat: Infinity,
        repeatDelay: 2
      }} data-id="element-237">
            💩🔥
          </motion.div>)}
        <motion.div className="max-w-2xl mx-auto text-center relative z-10" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} data-id="element-238">
          <motion.div className="text-6xl mb-8" initial={{
          rotate: 0
        }} animate={{
          rotate: [0, -10, 10, -10, 10, 0]
        }} transition={{
          delay: 0.5,
          duration: 1
        }} data-id="element-239">
            💩🔥
          </motion.div>
          <motion.h1 className="text-3xl md:text-4xl font-bold mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} data-id="element-240">
            {validationMessage}
          </motion.h1>
          <motion.p className="text-text-secondary mb-12" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} data-id="element-241">
            Your rant has been added to the IBD Hall of Rage.
            <br data-id="element-242" />
            Thanks for letting it out.
          </motion.p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-243">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8,
            duration: 0.5
          }} data-id="element-244">
              <Link to="/hall-of-rage" className="btn-primary py-3 px-6 rounded-lg flex items-center gap-2" data-id="element-245">
                <FlameIcon className="h-5 w-5" data-id="element-246" />
                See what others are ranting about
              </Link>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1,
            duration: 0.5
          }} data-id="element-247">
              <Link to="/" className="py-3 px-6 rounded-lg border border-gray-700 hover:border-primary text-text-primary hover:text-primary transition-colors flex items-center gap-2" data-id="element-248">
                Add another rant
                <ArrowRightIcon className="h-5 w-5" data-id="element-249" />
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </main>
      <Footer data-id="element-250" />
      <AnimatePresence data-id="element-251">
        {showEmailPrompt && !isCheckingAuth && <EmailSignupPrompt onDismiss={() => setShowEmailPrompt(false)} data-id="element-252" />}
      </AnimatePresence>
    </div>;
};